// import { result } from "lodash";
// import { useState } from "react";
// import { CommonUrl } from "../../../common-url/CommonUrl";
import { LOGIN_URL, ME_URL, REGISTER_URL, REQUEST_PASSWORD_URL } from "../_redux/authCrud";
// import { login } from "../_redux/authCrud";
import userTableMock from "./userTableMock";
// import axios from "axios";
// var md5 = require('md5');

export default function mockAuth(mock) {

	// const [user, setUser] = useState({})
	mock.onPost(LOGIN_URL).reply(({ data }) => {
		const { email, password } = JSON.parse(data);
		// console.log(email + "....." + password);
		// console.log(data, "data from mock auth.........");
		if (email && password) {

			// var encPass = md5(password)
			// fetch("http://localhost:6001/api/admin/auth/login", {
			// 	method: "post",
			// 	headers: {
			// 		'Content-Type': 'application/json',
			// 		'Accept': 'application/json'
			// 	},
			// 	body: JSON.stringify({
			// 		vEmail: email,
			// 		vPassword: encPass
			// 	}),
			// }).then(response => response.json())
			// 	.then(response => {
			// 		if (response.code == 200) {
			// 			console.log(response, ".......login response")
			// 			localStorage.setItem("authToken", response.accessToken)
			// 			const user = response.data[0]
			// 			// localStorage.setItem("user", (response))
			// 			// var token = localStorage.getItem("authToken")
			// 			// console.log(token, "token........")
			// 			console.log(user, "user..........")
			// 			// history.push("/")
			// 			return [200, { user }]
			// 		} else {
			// 			console.log("login fail")
			// 		}
			// 	});


			// return


			const user = userTableMock.find(
				x =>
					x.email.toLowerCase() === email.toLowerCase() &&
					x.password === password
			);
			console.log(user, "user............")
			if (user) {
				return [200, { ...user, password: undefined }];
			}
		}
		// if (email && password) {
		// 	fetch(LOGIN_URL, {
		// 		method: "POST",
		// 		body: JSON.stringify({ email, password }),
		// 		headers: { "Content-Type": "application/json" },
		// 	})
		// .catch (error => console.warn(error));
		// .then((response) => response.json()).then((result) => {
		// 	if (result.status == true) {
		// 		let userData = result.data.user_data;
		// 		return [200, { ...userData, password: undefined }];
		// 	}
		// 	return [400];
		// })
		// } else {
		// return [400];
		// }

		return [400];
	});

	mock.onPost(REGISTER_URL).reply(({ data }) => {
		const { email, fullname, username, password } = JSON.parse(data);

		if (email && fullname && username && password) {
			const user = {
				id: generateUserId(),
				email,
				fullname,
				username,
				password,
				roles: [2], // Manager
				accessToken: "access-token-" + Math.random(),
				refreshToken: "access-token-" + Math.random(),
				pic: process.env.PUBLIC_URL + "/media/users/default.jpg",
			};

			userTableMock.push(user);

			return [200, { ...user, password: undefined }];
		}

		return [400];
	});

	mock.onPost(REQUEST_PASSWORD_URL).reply(({ data }) => {
		const { email } = JSON.parse(data);

		if (email) {
			const user = userTableMock.find((x) => x.email.toLowerCase() === email.toLowerCase());

			if (user) {
				user.password = undefined;

				return [200, { ...user, password: undefined }];
			}
		}

		return [400];
	});

	mock.onGet(ME_URL).reply(({ headers: { Authorization } }) => {
		const accessToken = Authorization && Authorization.startsWith("Bearer ") && Authorization.slice("Bearer ".length);

		if (accessToken) {
			const user = userTableMock.find((x) => x.accessToken === accessToken);

			if (user) {
				return [200, { ...user, password: undefined }];
			}
		}

		return [401];
	});

	function generateUserId() {
		const ids = userTableMock.map((el) => el.id);
		const maxId = Math.max(...ids);
		return maxId + 1;
	}
}
